import { TFunction } from 'i18next';
import { DateTimeFormatType, localizeDateTime } from '~common/helper/datetime';
import { EventState } from '~client/model/event-state';
import { EventListData } from '~admin/model/event-list-data';

/**
 * Returns formatted date or other date related information
 * @param t
 * @param eventData
 */
export const getEventDate = (t: TFunction, eventData: EventListData): string => {
  const { state, eventStartDate } = eventData;

  switch (state) {
    case EventState.CANCELLED:
      return t('viewEvents.date.cancelled');
    case EventState.POSTPONED:
      return t('viewEvents.date.postponed');
    case EventState.RESCHEDULED:
    case EventState.UPCOMING:
    default:
      return localizeDateTime(eventStartDate, DateTimeFormatType.MEDIUM);
  }
};



// WEBPACK FOOTER //
// ./view/components/view-events/view-events.helper.ts